<template>
    <div>
        <div class="buildingListContainer">
            <div class="">
                <table class="table table-bordered table-striped table-condensed" v-if="showBuildingInformation">
                    <caption align="top" style="caption-side: top;">
                        <div class="form-group hasSearch">
                            <input type="text" class="form-control hasSearch-formControl" v-model="searchText" placeholder="Search building">
                            <i class="fa fa-search hasSearch-icon"></i>
                        </div>
                    </caption>
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Contract No</th>
                        <th>Strata No</th>
                        <th>Address</th>
                        <th>Edit</th>
                        <th>Assign to User</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(building,index) in pagedBuilding">
                        <tr v-on:click="togglePanel(building.id)" style="cursor: pointer" v-bind:key="`BuildingIdT${building.id}`">
                            <td class="text-break">{{building.name}}</td>
                            <td class="text-break">{{building.contract_no}}</td>
                            <td class="text-break">{{building.strata_no}}</td>
                            <td class="text-break">{{building.fullAddress}}</td>
                            <td>
                                <router-link class="btn btn-outline-primary" v-bind:to="{name: 'edit-building', params: { buildingId: building.id }}">
                                    Edit
                                </router-link>
                            </td>
                            <td class="text-nowrap">
                                <router-link class="btn btn-outline-primary" v-bind:to="{name: 'assign-building-to-user',params:{buildingId:building.id}}">
                                    Assign To User
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="currentBuildingId === building.id" class="bg-light" v-bind:key="`BuildingIdD${building.id}`">
                            <td colspan="7">
                                <ul>
                                    <li><p>Latitude: {{building.latitude}}</p></li>
                                    <li><p>Longitude: {{building.longitude}}</p></li>
                                    <li><p>Key: {{building.key}}</p></li>
                                    <li><p>Parking: {{building.parking}}</p></li>
                                    <li><p>Toilet: {{building.toilet}}</p></li>
                                    <li>
                                        <p>Access code for "view the latest report", url: <a v-if="vr[building.id]" v-bind:href="vr[building.id][0]" target="_blank">{{vr[building.id][0]}}</a><span v-else>N/A</span></p>
                                        <p v-if="vr[building.id]"><img v-bind:src="vr[building.id][1]"/></p>
                                        <p><button v-if="vr[building.id]" class="btn btn-info"v-on:click="printQrCode(building)">Print access code</button></p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="paginationSection" v-if="client.totalPage > 1">
                <paginate
                        v-model="client.currentPage"
                        :page-count="client.totalPage"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-link-class="'page-link'"
                        :page-link-class="'page-link'">
                </paginate>
            </div>
            <DeleteModalComponent v-if="dataToPassToModal.showModal" @close="dataToPassToModal.showModal = false"
                                  :confirm="confirm" :dataToPassToModal="dataToPassToModal"
                                  :dataObject="buildings"></DeleteModalComponent>
            <transition name="fade">
                <div v-if="response.isMaxPaginationLimit" class="alert alert-danger">Maximum Limit has been exceeded.
                    Cannot
                    show more results
                </div>
            </transition>
        </div>
        <div ref="view_latest_report_qrcode" class="d-none"></div>
        <iframe ref="view_latest_report_print" src="javascript:void(0)" class="d-none"></iframe>
    </div>
</template>
<style lang="scss" scoped>
    @import "@/../sass/_mixins.scss";
    .buildingListContainer {
        width: 100%;
        @include building-search;
    }
</style>
<script>
  import Vue from 'vue';
  import Tools from '@/app-model/tools.js';
  import Building from '@/app-model/building.js';
  import DeleteModalComponent from '@/components/modal/DeleteConfirmModalComponent.vue';
  import QRCodeFn from '@/utils/qrcode.js';
  import QRCodeClass from '@/app-model/qr_code.js';

  export default {
    components: {
      DeleteModalComponent
    },
    data () {
      return {
        currentBuildingId: undefined,
        searchText: '',
        showBuildingInformation: false,
        perPage: 100,
        currentPage: 0,
        totalPage: 0,
        buildings: [],
        client: {
          totalPage: 0,
          currentPage: 1,
          perPage: 50,
        },
        vr: {},
        confirm: {
          action: '',
          title: '',
          msg: ''
        },
        dataToPassToModal: {
          id: '',
          index: '',
          showModal: false,
        },
        response: {
          isMaxPaginationLimit: false
        }
      }
    },
    created () {
      this.fetchBuildings()
    },
    computed: {
      tools: function () {
        return new Tools
      },
      QRCode() {
        return QRCodeFn();
      },
      buildingModel: function () {
        return new Building;
      },
      buildingFilted: function () {
        return this.buildings.filter((el) => {
          let searchText = this.searchText
              .replace(/\W/g, ' ')
              .replace(/\s+/g, ' ')
              .toLowerCase()
              .split(' ')
              .filter(txt => txt !== ''),
            context = (el.fullAddress + ' ' + el.strata_no + ' ' + el.name).toLowerCase();
          if(this.searchText.length) {
            for(let i = 0; i < searchText.length; i++) {
              if(context.indexOf(searchText[i]) === -1){
                return false;
              }
            }
          }
          return true;
        });
      },
      pagedBuilding: function() {
        this.client.totalPage = Math.ceil(this.buildingFilted.length / this.client.perPage);
        const currentPage = Math.min(this.client.currentPage, this.client.totalPage);
        let start = (currentPage - 1) * this.client.perPage,
          end = start + this.client.perPage;

        return this.buildingFilted.slice(start, end);
      }
    },
    methods: {
      printQrCode(building) {
        let el = this.$refs['view_latest_report_print'];
        let QRCodeTemplate = new QRCodeClass(el, building, this.vr[building.id][1]);
        QRCodeTemplate.loadBody();
        QRCodeTemplate.loadHead();
        QRCodeTemplate.loadPrintTrigger();
        el.contentWindow.document.close();
        el.contentWindow.focus();
      },
      togglePanel(building_id) {
        let currentBuildingId = this.currentBuildingId !== building_id ? building_id : undefined;
        let top = this;
        if (currentBuildingId) {
          if(!this.vr[building_id]) {
            this.$store.dispatch('apiResult', {
              method: 'GET',
              path: `api/building-access-code/${building_id}/report`,
              path_template: '/api/building-access-code/{building_id}/report'
            }).then(response => {
              switch (response.status) {
                case 200:
                  let obj = {}, el = this.$refs['view_latest_report_qrcode'];
                  obj[building_id] = response.data.data.uri;
                  let qrcode = new this.QRCode(el, {
                    text: response.data.data.uri,
                    width: 92.59 * 4,
                    height: 92.59 * 4,
                    correctLevel : this.QRCode.CorrectLevel.M
                  });

                  qrcode._oDrawing._elImage.onload = () => {
                    Vue.set(this.vr, building_id, [response.data.data.uri, qrcode._oDrawing._elImage.src]);
                    el.innerHTML = '';
                  };
                  break;
              }
            });
          }
        }

        this.currentBuildingId = currentBuildingId;
      },
      fetchPagedBuildings (page) {
        return this.$store.dispatch('apiResult', {
          method: 'GET',
          path: 'api/buildings?page=' + (page + 1) + '&per_page=' + this.perPage,
          path_template: '/api/buildings'
        }).then(response => {
          switch (response.status) {
            case 200 :
              for (let building of response.data.data) {
                if (!building.id) {
                  continue;
                }
                Object.assign(
                  building,
                  {
                    fullAddress: this.buildingModel.fullAddress(building)
                  }
                );
                this.buildings.push(building);
              }

              this.currentPage ++;

              if(!this.totalPage) {
                this.totalPage = response.data.meta.last_page;
              }

              this.showBuildingInformation = this.currentPage === this.totalPage;
              break;
            case 401 :
              this.showErrorMessage = true;
              break;
          }

          return response;
        });
      },
      async fetchBuildings () {
        this.buildings = [];
        this.currentPage = 0;
        this.totalPage = 0;
        let response = await this.fetchPagedBuildings(0);
        switch (response.status) {
          case 200 :
            for(let i = 1; i < response.data.meta.last_page; i++) {
              this.fetchPagedBuildings(i);
            }
            break;
        }
      },
      confirmPopup: function (action, buildingId, index) {
        this.confirm = {
          action: action,
          title: 'Are you sure to execute: ' + action,
          msg: action + ' will delete this Building',
        }
        this.dataToPassToModal.id = buildingId
        this.dataToPassToModal.index = index
        this.dataToPassToModal.router = 'api/buildings/'
        this.dataToPassToModal.showModal = true
        this.dataToPassToModal.pathTemplate = '/api/buildings/{id}'
      },
    }
  }
</script>
